module.exports = __webpack_public_path__ + "static/media/moving-home-transport-for-boxes-svgrepo-com.9fc6d124.svg";